<div class="modal-header">
  <h4 class="modal-title pull-left">Sale Details</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
      <div class="form-group">
        <label class="form-label">
          Event
          <span class="star">*</span>
        </label>
        <label class="select">
          <select class="form-control" #lstEvent="ngModel" required [(ngModel)]="currentData.EventId" (ngModelChange)="onEventChange($event);validateEvent()">
            <option [ngValue]="str.id" *ngFor="let str of leaseEventList">{{str.description}}</option>
          </select>
          <i></i>
        </label>
        <div *ngIf="!isEventValid">
          <p class="redtext" *ngIf="lstEvent.errors.required">
            Event is required
          </p>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Sale Date<span class="star">*</span></label>
        <div class="textbox-date">
          <input type="text" maxlength="10" name="txtSaleDate" #SaleDate="ngModel" autocomplete="off" [(ngModel)]="currentData.SaleDate" (ngModelChange)="validateDate();getTimeOnMarket($event);" required="required" class="form-control" bsDatepicker>
          <i class="icofont icofont-ui-calendar icon"></i>
          <p class="redtext" *ngIf="!isValidDate">
            Please enter a valid date
          </p>
          <p class="redtext" *ngIf="(validationService.IsinValid(currentData.SaleDate) && isSubmit) ||(SaleDate.invalid && SaleDate.touched)">Sale Date is required </p>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Sale Price<span class="star">*</span></label>
        <div class="textbox-with-btn-left">
          <input (keyup)="reCalcSalesRates(3,true);getDiscountToAsking(inputCalcDiscount.checked,1);" class="form-control" #SalePrice="ngModel" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="currentData.SalePrice" maxlength="15"
                 value="{{currentData.SalePrice | number}}">
          <span class="leftlabel">$</span>
        </div>
        <p class="redtext" *ngIf="(validationService.IsinValid(currentData.SalePrice) && isSubmit) ||(SalePrice.invalid && SalePrice.touched)">Sale Price is required </p>
      </div>
      <div class="form-group">
        <label class="form-label">
          Sale Cap Rate<span class="star">*</span>
          <label class="custom-checkbox" style="float:right; height:10px" for="chkCalcCAP_Sales">
            <input #inputCalcCAP id="chkCalcCAP_Sales" (ngModelChange)="reCalcSalesRates(1,inputCalcCAP.checked)" type="checkbox" [(ngModel)]="currentData.AutoCalcCapRate"> Auto Calc Cap Rate
            <i></i>
          </label>
        </label>
        <div class="textbox-with-btn textbox-with-2character">
          <input (keyup)="currentData.AutoCalcCapRate=false" class="form-control" #CapRate="ngModel" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="currentData.SaleCapRate" maxlength="6" (ngModelChange)="validatePercentage()"
                 value="{{currentData.SaleCapRate | number}}">
          <span class="rightlabel">%</span>
        </div>
        <div *ngIf="!isValidCaprate">
          <p class="redtext" *ngIf="currentData.SaleCapRate>100">
            Cap Rate cannot be greater than 100
          </p>
          <p class="redtext" *ngIf="currentData.SaleCapRate<0">
            Cap Rate cannot be less than 0
          </p>
        </div>
        <p class="redtext" *ngIf="(validationService.IsinValid(currentData.SaleCapRate) && isSubmit) ||(CapRate.invalid && CapRate.touched)">Sale Cap Rate is required </p>
      </div>
      <div class="form-group">
        <label class="form-label">
          Sale PSF
          <label class="custom-checkbox " style="float:right; height:10px" for="chkCalcPSF_Sales">
            <input #inputCalcPSF id="chkCalcPSF_Sales" (ngModelChange)="reCalcSalesRates(2,inputCalcPSF.checked)" type="checkbox" [(ngModel)]="currentData.AutoCalcPSF"> Auto Calc PSF
            <i></i>
          </label>
        </label>
        <div class="textbox-with-btn-left">
          <input type="text" inputmode="numeric" (keyup)="currentData.AutoCalcPSF=false" thousandSeparator="," maxlength="21" mask="separator.10.2" dropSpecialCharacters="false" name="txtPricePSF" [(ngModel)]="currentData.SalePSF" (change)="validationService.onlyDecimal($event);"
                 class="form-control">
          <!--<input (keyup)="currentData.AutoCalcPSF=false" inputmode="numeric" class="form-control" [dropSpecialCharacters]="false" thousandSeparator=","  mask="999999999999999.99" [(ngModel)]="currentData.SalePSF" maxlength="15"
                 (change)="validationService.onlyDecimal($event)">-->
          <span class="leftlabel">$</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Property Brought To Market</label>
        <div class="textbox-date">
          <input type="text" maxlength="10" name="txtSaleDate" (bsValueChange)="getTimeOnMarkeEvent($event);" (change)="getTimeOnMarket($event);" autocomplete="off" [(ngModel)]="currentData.DateOnMarket" class="form-control" bsDatepicker>
          <i class="icofont icofont-ui-calendar icon"></i>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Time on Market</label>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="text" placeholder="Years" [(ngModel)]="currentData.YearOnMarket" maxlength="5">
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="text" placeholder="Months" [(ngModel)]="currentData.MonthOnMarket" maxlength="5">
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="text" placeholder="Days" [(ngModel)]="currentData.DayOnMarket" maxlength="5">
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Remaining Term <span class="star">*</span></label>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="text" placeholder="Years" [(ngModel)]="currentData.RemainingTermYear" maxlength="5">
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="text" placeholder="Months" [(ngModel)]="currentData.RemainingTermMonth" maxlength="5">
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <input class="form-control" type="text" placeholder="Days" [(ngModel)]="currentData.RemainingTermDay" maxlength="5">
          </div>
        </div>
        <p class="redtext" *ngIf="(validationService.IsinValid(currentData.RemainingTermYear) &&
                   (validationService.IsinValid(currentData.RemainingTermMonth) && validationService.IsinValid(currentData.RemainingTermDay)) && isSubmit)">Remaining Term is required</p>
      </div>
      <div class="form-group">
        <label class="form-label">Asking Price</label>
        <div class="textbox-with-btn-left">
          <input class="form-control" (keyup)="getDiscountToAsking(inputCalcDiscount.checked,1);" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="currentData.AskingPrice" maxlength="15"
                 value="{{currentData.AskingPrice | number}}">
          <span class="leftlabel">$</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Asking Cap Rate</label>
        <div class="textbox-with-btn textbox-with-2character">
          <input class="form-control" autocomplete="off" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="currentData.AskingCapRate" maxlength="6"
                 value="{{currentData.AskingCapRate | number}}">
          <span class="rightlabel">%</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          Discount to Asking %
          <label class="custom-checkbox" style="float:right; height:10px" for="chkCalcDiscount">
            <input #inputCalcDiscount id="chkCalcDiscount" (ngModelChange)="getDiscountToAsking(inputCalcDiscount.checked,1);" type="checkbox" [(ngModel)]="currentData.AutoCalcDiscount"> Auto Calc Discount
            <i></i>
          </label>
        </label>
        <div class="textbox-with-btn textbox-with-2character" *ngIf="showDiscount">
          <input class="form-control" [dropSpecialCharacters]="false" mask="999.99" (keyup)="getDiscountToAsking(false,2);" [(ngModel)]="currentData.DiscountToAsking" maxlength="15"
                 value="{{currentData.DiscountToAsking | number}}">
          <span class="rightlabel">%</span>
        </div>
        <input class="form-control" type="text" *ngIf="!showDiscount" value="Not Applicable" disabled>
        <!--<div *ngIf="!isValidCaprate">
            <p class="redtext" *ngIf="currentData.SaleCapRate>100">
                Cap Rate cannot be greater than 100
            </p>
            <p class="redtext" *ngIf="currentData.SaleCapRate<0">
                Cap Rate cannot be less than 0
            </p>
        </div>-->
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
      <div class="form-group">
        <label class="form-label">Buyer</label>
        <input class="form-control" type="text" [(ngModel)]="currentData.BuyerName" maxlength="100">
      </div>
      <div class="form-group">
        <label class="form-label">Buyer Brokerage</label>
        <label class="select">
          <select [(ngModel)]="currentData.BuyerBrokerageId" class="form-control">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let brokerage of brokerageList" [(ngValue)]="brokerage.Id">{{brokerage.BrokerageName}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">Buyer Broker</label>
        <input class="form-control" type="text" [(ngModel)]="currentData.BuyerBrokerName" maxlength="100">
      </div>
      <div class="form-group">
        <label class="form-label">Seller</label>
        <input class="form-control" type="text" [(ngModel)]="currentData.SellerName" maxlength="100">
      </div>
      <div class="form-group">
        <label class="form-label">Seller Brokerage</label>
        <label class="select">
          <select [(ngModel)]="currentData.BrokerageId" class="form-control">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let brokerage of brokerageList" [(ngValue)]="brokerage.Id">{{brokerage.BrokerageName}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">Seller Broker</label>
        <input class="form-control" type="text" [(ngModel)]="currentData.SellerBrokerName" maxlength="100">
      </div>
      <div class="form-group">
        <label class="form-label">Guarantor</label>
        <label class="select">
          <select [(ngModel)]="currentData.GuarantorId" (change)="onGuarantorChanges();" class="form-control" (ngModelChange)="setPropertyNames($event,1)">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let guarantor of guarantorList" [(ngValue)]="guarantor.Id">{{guarantor.Name}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">S&P Rating</label>
        <label class="select">
          <select [(ngModel)]="currentData.SPRatingId" class="form-control" (ngModelChange)="setPropertyNames($event,2)">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let item of sprRatingList" [(ngValue)]="item.id">{{item.description}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">Moody's Rating</label>
        <label class="select">
          <select [(ngModel)]="currentData.MoodyRatingId" class="form-control" (ngModelChange)="setPropertyNames($event,3)">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let item of moodysRatingList" [(ngValue)]="item.id">{{item.description}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">Fitch Rating</label>
        <label class="select">
          <select [(ngModel)]="currentData.FitchRatingId" class="form-control" (ngModelChange)="setPropertyNames($event,4)">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let item of fitchRatingList" [(ngValue)]="item.id">{{item.description}}</option>
          </select>
          <i></i>
        </label>
      </div>
      <div class="form-group">
        <label class="form-label">Lease Structure</label>
        <label class="select">
          <select [(ngModel)]="currentData.LeaseStructureId" class="form-control">
            <option [ngValue]="null">Select</option>
            <option [ngValue]="str.id" *ngFor="let str of leaseStructureList">{{str.description}}</option>
          </select>
          <i></i>
        </label>
      </div>

      <!--<div class="form-group margin-top-30">
          <label class="custom-checkbox margin-right-20 margin-bottom-0" for="chkIs1031ExchangeBuyer">
              <input type="checkbox" id="chkIs1031ExchangeBuyer" [(ngModel)]="currentData.Is1031ExchangeBuyer">
              Is 1031 Exchange Buyer
              <i></i>
          </label>
      </div>-->
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
      <div class="form-group">
        <label class="form-label">NOI</label>
        <div class="textbox-with-btn-left">
          <input class="form-control" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="currentData.SalesNOI" maxlength="15"
                 value="{{currentData.SalesNOI | number}}">
          <span class="leftlabel">$</span>
        </div>
      </div>
      <label class="bluelabel" style="font-size: 13px ;margin: 0 0 5px 0">Escalation</label>
      <div class="form-group">
        <label class="form-label">Percentage</label>
        <div class="textbox-with-btn textbox-with-2character">
          <input class="form-control" autocomplete="off" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="currentData.RentEscalationPercentage" maxlength="6"
                 value="{{currentData.RentEscalationPercentage | number}}">
          <span class="rightlabel">%</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Period</label>
        <div class="textbox-with-btn textbox-with-4character">
          <input [(ngModel)]="currentData.RentEscalationPeriod" type="text" mask="9999" class="form-control">
          <span class="rightlabel">Years</span>
        </div>
      </div>
      <label class="bluelabel" style="font-size: 13px ;margin: 0 0 5px 0">Option</label>
      <div class="form-group">
        <label class="form-label">Number</label>
        <input class="form-control" type="text" [(ngModel)]="currentData.OptionNumber" mask="999999999">
      </div>
      <div class="form-group">
        <label class="form-label">Length</label>
        <div class="textbox-with-btn textbox-with-4character">
          <input min="0" [(ngModel)]="currentData.OptionLength" type="text" mask="9999" class="form-control">
          <span class="rightlabel">Years</span>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Sale Characteristics</label>
        <div class="select-dropdown multiselectdesign select-check">
          <mat-form-field>
            <mat-select placeholder="Select" [(ngModel)]="currentData.SaleCharacteristicsId" multiple (ngModelChange)="onSaleCharacteristicsChange($event.value)">
              @if(currentData?.SaleCharacteristicsId?.length > 1) {
              <mat-select-trigger>
                <span>{{ currentData?.SaleCharacteristicsId.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (characteristic of salesCharacteristics; track characteristic) {
              <mat-option [value]="characteristic.id" class="multi-dropdown-item">{{characteristic.name}}</mat-option>
              }
              <mat-option class="matoptionnodata" *ngIf="salesCharacteristics?.length === 0" disabled>
                Nothing found...
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group" *ngIf="showSaleCharacteristics">
        <label class="form-label">LTV</label>
        <div class="textbox-with-btn textbox-with-2character">
          <input class="form-control" type="text" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="currentData.LTV" maxlength="15"
                 value="{{currentData.LTV | number}}">
          <span class="rightlabel">%</span>
        </div>
      </div>
      <div class="form-group" *ngIf="showSaleCharacteristics">
        <label class="form-label">Interest Rate</label>
        <div class="textbox-with-btn textbox-with-2character">
          <input class="form-control" type="text" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="currentData.InterestRate" maxlength="15"
                 value="{{currentData.InterestRate | number}}">
          <span class="rightlabel">%</span>
        </div>
      </div>
      <div class="form-group" *ngIf="showSaleCharacteristics">
        <label class="form-label">Amortization</label>
        <input class="form-control" type="text" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="currentData.Amortization" maxlength="15"
               value="{{currentData.Amortization | number}}">
      </div>
      <div class="form-group" *ngIf="showSaleCharacteristics">
        <label class="form-label">Term</label>
        <input class="form-control" type="text" dropSpecialCharacters="false" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" [(ngModel)]="currentData.Term" maxlength="15"
               value="{{currentData.Term | number}}">
      </div>
      <div class="form-group">
        <label class="form-label">Sales Notes</label>
        <textarea class="form-control property-description" maxlength="500" [(ngModel)]="currentData.SalesNotes" rows="3"></textarea>
      </div>
      <div class="form-group docs-list">
        <label class="form-label">Documents</label>
        <!--<div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Documents" placement="left">
            <input type="file" (change)="onNewFileUpload($event)" multiple #saleHistoryDoc class="fileupload">
            <span class="icofont icofont-upload-alt icon"></span>
        </div>-->
        <ng-container *ngFor="let doc of documents; let i= index">
          <p>
            <label>{{i + 1}} </label>
            <a *ngIf="doc.Url != null && doc.Url != undefiend && doc.Url.length > 0" href="{{doc.Url}}" download target="_blank">{{doc.Name}}</a>
            <span style="cursor:none !important" *ngIf="doc.Url == null || doc.Url == undefiend || doc.Url.length == 0">{{doc.Name}}</span>
            <span (click)="onRemoveDocument(i)" tooltip="Remove" class="remove">
              <i aria-hidden="true" class="icofont icofont-close"></i>
            </span>
          </p>

        </ng-container>
      </div>
      <div class="form-group">
        <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles"></file-upload>
      </div>
      <!--{{isDataSaved}}
      <p>-------currentData-----------------------------------------------</p>
      {{currentData|json}}
      <p>---------currentSalesDetails---------------------------------------------</p>
      {{currentSalesDetails|json}}
      <p>--------property----------------------------------------------</p>
      {{property|json}}-->
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="form-group margin-top-30">
        <div class="row">
          <div class="col-sm-6 margin-bottom-10">
            <label class="bluelabel" style="font-size: 16px;">
              NOI / Rent Schedule

            </label>

          </div>
          <div class="cols-sm-6">
            <div class="btn-group right-btn rightdropdown pull-right" dropdown style="margin-right: 10px;margin-top: 5px;">
              <button id="button-basic" dropdownToggle type="button" class="btn  btn-circle btn-green margin-bottom dropdown-toggle"
                      aria-controls="dropdown-basic">
                <i aria-hidden="true" class="fa fa-plus icon"></i>
              </button>
              <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
                  role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" (click)="addRentTerm()">Add Rent Schedule</a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="addRentTermOption()">Add Rent Schedule Option</a></li>
              </ul>
            </div>
          </div>
        </div>


        <app-property-history-rent-term [saleDate]="currentData.SaleDate" (saveRentTerm)="saveHistoryRentTerm($event)" [PropertyHistoryRentTerms]="propertyHistoryRentTerms" [IsEditAllowed]="true"></app-property-history-rent-term>
      </div>
      <div class="text-right">
        <button type="button" (click)="onClose($event)" class="btn btn-default btn-lg">Cancel</button>
        <button type="button" (click)="saveSalesDetails()" class="btn btn-success btn-lg">Save</button>
      </div>
    </div>
  </div>
</div>
